import _ from 'lodash';
import {computed, observable} from 'mobx';

export default class {
  @observable profile = {};
  @observable quizCompleted = false;
  @observable showMoreMenu = false;
  @observable showQuiz = false;
  @observable impactWrapperHeight = 0;

  @computed get truncatedBio() {
    return _.truncate(this.profile.bio, {
      'length': 300,
      'separator': /(,|.)? +/,
    });
  }

  @computed get profileUrl() {
    return `/someonelikeyou/profiles/${this.profile.slug}`;
  }

  @computed get tweetText() {
    return `${this.profile.name} is someone like me. Find out who's just like you in Adi Etot, Ethiopia with @charitywater https://www.charitywater.org/someonelikeyou/`;
  }

  loadProfile = (profileId, callback) => {
    $.ajax({
      url: `/api/v1/someone_like_you_profiles/${profileId}`,
      dataType: 'json',
      timeout: '2000',
      success: (data) => {
        this.profile = {...data};
        if (callback) callback();
      },
    });
  };

  saveProfile = (profileId) => {
    $.ajax({
      data: { user: { someone_like_you_profile_id: profileId } },
      dataType: 'json',
      method: 'PUT',
      timeout: '2000',
      url: '/api/v1/user',
      success: () => {},
    });
  };
}
